class StatsSender {
    constructor(prefix = 'imlcht') {
        this.partner = prefix;
    }

    sendEvent(useraction, msg) {

        if (!useraction) {
            return;
        }

        const now = new Date();
        const year = now.getUTCFullYear();
        const month = String(now.getUTCMonth() + 1).padStart(2, '0');
        const day = String(now.getUTCDate()).padStart(2, '0');
        const hours = String(now.getUTCHours()).padStart(2, '0');
        const minutes = String(now.getUTCMinutes()).padStart(2, '0');
        const seconds = String(now.getUTCSeconds()).padStart(2, '0');
        const currTimestamp = `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;

        let impressionId = localStorage.getItem('impressionId');
        if (!impressionId) {
            impressionId = crypto.randomUUID();
            localStorage.setItem('impressionId', impressionId);
        }
        
        const data = {
            useraction,
            currTimestamp,
            impressionid:impressionId,
            partner: this.partner,
            webpath: window.location.pathname,
            queryString: encodeURIComponent(window.location.search),
            origin: window.location.hostname,
            eventName: "impression",
            ...(msg && { msg })
        };

        const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
        navigator.sendBeacon(`/postback/${this.partner}`, blob);
    }

    getImpressionId() {
        return localStorage.getItem('impressionId');
    }

    actions =  {
        signup_status: 'signup_status',
        submit_code_correct: 'submit_code_correct',
        submit_code_incorrect: 'submit_code_incorrect',
        impression: 'impression',
        redirect_to_site: 'redirect_to_site',
        error_general: 'error_general',
        error_failed: 'error_failed',
        error_status_500_invalid_email: 'error_status_500_invalid_email',
        registered: 'registered',
        form_input_focus: 'form_input_focus',
        click_form_suggestion: 'click_form_suggestion'
    }
}

export default StatsSender;